var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-management" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.hasAdminRole()
        ? _c(
            "b-button",
            {
              staticClass: "mb-3",
              attrs: { variant: "success" },
              on: {
                click: function($event) {
                  return _vm.syncWithAD({
                    $toasted: _vm.$toasted,
                    tenantId: _vm.currentUser.selectedCountryId
                  })
                }
              }
            },
            [_vm._v("Sync with AD")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: "List of users" } },
        [
          _c("v-client-table", {
            attrs: {
              data: _vm.users,
              columns: _vm.columnsDatatable,
              options: _vm.optionsDatatable
            },
            scopedSlots: _vm._u([
              {
                key: "Last logged in",
                fn: function(props) {
                  return _c("div", {}, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatDate(props.row.lastLoggedIn)) +
                        "\n            "
                    )
                  ])
                }
              },
              {
                key: "roles",
                fn: function(props) {
                  return _c(
                    "div",
                    {},
                    _vm._l(props.row.userAuthorities, function(authority, i) {
                      return _c(
                        "span",
                        { key: i, staticClass: "flex inline" },
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "info", pill: "" }
                            },
                            [_vm._v(_vm._s(authority.role))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-top-line" }, [
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("User - "),
        _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Management")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }